import React from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { NoAuthGuard } from "src/modules/auth/components/NoAuthGuard";
import { RouteGuard } from "src/modules/auth/components/RouteGuard";
import { UnAuthGuard } from "src/modules/auth/components/UnAuthGuard";
import { ROUTES } from "./routes";

export function AppRouting() {
  return (
    <BrowserRouter>
      <Switch>
        {ROUTES.map((route, i) => (
          <Route key={i} path={route.path}>
            {route.guard ? (
              <RouteGuard path={route.path} redirectPath="/auth">
                {<route.component />}
              </RouteGuard>
            ) : route.path === "/unauthorized" ? (
              <UnAuthGuard path={route.path} redirectPath="/auth/login">
                {<route.component />}
              </UnAuthGuard>
            ) : (
              <NoAuthGuard path={route.path} redirectPath="/nod/insights">
                {<route.component />}
              </NoAuthGuard>
            )}
          </Route>
        ))}
        <Redirect to={{ pathname: "/nod/insights" }} />
      </Switch>
    </BrowserRouter>
  );
}
